if (!customElements.get('gd-slideshow')) {
  customElements.define('gd-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.index = 0;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-go]')];
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
      this.hovered = false;
      this.focused = false;
      this.querySelector('.gd-slide-controls')?.removeAttribute('hidden');
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), options);
      this.dots.forEach(dot => dot.addEventListener('click', () => this.show(Number(dot.dataset.go)), options));
      this.querySelector('[data-toggle]')?.addEventListener('click', () => { this.playing = !this.playing; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => {this.hovered = true; this.schedule();}, options);
      this.addEventListener('mouseleave', () => {this.hovered = false; this.schedule();}, options);
      this.addEventListener('focusin', () => {this.focused = true; this.schedule();}, options);
      this.addEventListener('focusout', event => {if (!this.contains(event.relatedTarget)) {this.focused = false; this.schedule();}}, options);
      this.addEventListener('keydown', event => {if (event.target.matches('input, textarea, select')) return; if (event.key === 'ArrowRight') {event.preventDefault(); this.show(this.index + 1);} if (event.key === 'ArrowLeft') {event.preventDefault(); this.show(this.index - 1);}}, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {if (this.motion.matches) this.playing = false; this.schedule();}, options);
      document.addEventListener('shopify:block:select', event => {const i = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target)); if (i >= 0) {this.playing = false; this.show(i);}}, options);
      this.schedule();
    }
    show(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {slide.hidden = i !== this.index; slide.inert = i !== this.index; slide.classList.toggle('is-active', i === this.index);});
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      const toggle = this.querySelector('[data-toggle]');
      if (toggle) {toggle.textContent = this.playing ? 'Ⅱ' : '▷'; toggle.setAttribute('aria-label', this.playing ? this.dataset.pause : this.dataset.play);}
      if (this.playing && !this.hovered && !this.focused && !document.hidden && this.slides.length > 1 && !window.Shopify?.designMode) this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
  });
}
